import { useQuery } from '@tanstack/react-query';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';

import Api from '@barboxx/api';
import { Substitution } from '@barboxx/models/types';

interface Props {
    disabled?: boolean;
}

interface SubstitutionWatchProps {
    substitution?: Substitution;
}

export function SubstitutionInput({ disabled = false }: Props) {
    const { substitution } =
        useFormContext<SubstitutionWatchProps>().getValues();
    const substitutionQueryResult = useQuery({
        queryKey: ['substitutions'],
        queryFn: () =>
            Api.Core.Substitution.getSubstitutions({
                page: 0,
                size: 1000,
                sort: 'name,asc',
            }),
        initialData: {
            ok: true,
            problem: null,
            originalError: null,
            data: {
                results: substitution ? [substitution] : [],
                total: 1,
                isPaginated: false,
            },
        },
    });

    return (
        <AutocompleteElement
            label="Substitution"
            name="substitutionId"
            loading={substitutionQueryResult.isLoading}
            multiple={false}
            options={substitutionQueryResult.data?.data?.results ?? []}
            transform={{
                output(event, value, reason, details) {
                    if (reason === 'selectOption') {
                        return typeof value === 'string' ? value : value?.id;
                    }
                    if (reason === 'removeOption') {
                        return null;
                    }
                    return value;
                },
            }}
            autocompleteProps={{
                fullWidth: true,
                readOnly: disabled,
                disabled: disabled,
                isOptionEqualToValue(
                    option?: Substitution,
                    value?: Substitution | number | null
                ) {
                    const isNumber = typeof value === 'number';

                    if (isNumber) {
                        return option?.id === value;
                    } else {
                        return option?.id === (value?.id ?? value);
                    }
                },
                getOptionLabel(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.name}`;
                },
            }}
        />
    );
}
